import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { AuthService } from '../service/auth.service';

export const adminMatch: CanMatchFn = () => {
  const authService = inject(AuthService);
  return authService.isAuthenticated() && authService.isAdmin();
};

export const userMatch: CanMatchFn = () => {
  const authService = inject(AuthService);
  return authService.isAuthenticated() && !authService.isAdmin();
};
